import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  AppBar,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  Box,
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { TreeView, TreeItem } from "@mui/lab";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EventNoteIcon from "@mui/icons-material/EventNote";
import { color } from "../StyleData/Config";
import { menulist } from "../SampleData/PMSample";
import { useDispatch, useSelector } from "react-redux";

const SideNav = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [listOpen, setListOpen] = useState({});
  const data = useSelector((state) => state.dataRed.menuList);
  const drawerOpen = useSelector((state) => state.auth.drawerOpen);


  const handleClick = (listType) => {
    setListOpen({ ...listOpen, [`${listType}`]: !listOpen[`${listType}`] });
  };

  const handleNavigate = (link) => {
    navigate(link);
  };

  // Shift Log menu links out to the external demo app instead of showing its
  // own sub-menu -- treat it as a leaf regardless of what children it has.
  const SHIFT_LOG_MENU_ID = "16bce716-4104-4975-901d-2f902e577a9d";
  const SHIFT_LOG_DEMO_URL = "https://shiftlogdemo.orienseam.com/";

  const renderTree = (nodes) => {
    const isShiftLogMenu = nodes.id === SHIFT_LOG_MENU_ID;
    const isLeaf = isShiftLogMenu || nodes.children === null;

    return (
      <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        label={
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              p: 1,
              gap: "0.6rem",
            }}
            onClick={() => {
              if (isShiftLogMenu) {
                window.open(SHIFT_LOG_DEMO_URL, "_blank", "noopener,noreferrer");
                return;
              }

              if (nodes.children === null) {
                if (nodes.openInNewTab) {
                  // Open in new tab
                  window.open(nodes.href, "_blank", "noopener,noreferrer");
                } else {
                  // Check if it's an external URL
                  const isExternalUrl = nodes.href?.startsWith('http://') || nodes.href?.startsWith('https://');

                  if (isExternalUrl) {
                    // Navigate to external URL in same tab
                    window.location.href = nodes.href;
                  } else {
                    // Navigate within app using React Router
                    if (nodes.module?.toUpperCase() === "ASSETS_EXPL") {
                      dispatch({ type: "drawerOpen", payload: { bol: true, open: false } });
                    } else {
                      dispatch({ type: "drawerOpen", payload: { bol: false, open: false } });
                    }
                    navigate(`${nodes.href}`);
                    if (isMobile && props.res === "main") {
                      props.onClose?.();
                    }
                  }
                }
              }
            }}
          >
            {isShiftLogMenu ? (
              <EventNoteIcon sx={{ fontSize: "1.4rem", color: color.sideFontColor }} />
            ) : (
              <img
                src={`${nodes.icon}`}
                style={{
                  width: "1.4rem",
                  height: "1.4rem",
                  display: isLeaf ? "default" : "none",
                }}
              />
            )}
            <Typography
              sx={{
                fontSize: "0.82rem",
                fontWeight: color.sideFontWeight,
                fontFamily: color.sideFontFamily,
                color: color.sideFontColor,
              }}
            >
              {nodes.name}
            </Typography>
          </Box>
        }
        sx={{ mt: 0.7, p: 0, ml: isLeaf ? -3.5 : 0 }}
      >
        {!isShiftLogMenu && Array.isArray(nodes.children)
          ? nodes.children.map((node) => renderTree(node))
          : null}
      </TreeItem>
    );
  };

  const isMainNav = props.res === "main";
  const mobileTemporary = isMainNav && isMobile;

  return (
    <Drawer
      variant={mobileTemporary ? "temporary" : "persistent"}
      anchor="left"
      open={drawerOpen.bol ? drawerOpen.open : props.open}
      onClose={props.onClose}
      ModalProps={mobileTemporary ? { keepMounted: true } : undefined}
      sx={{
        width: props.drawerWidth,
        flexShrink: 0,
        display: isMainNav ? "block" : "none",
        [`& .MuiDrawer-paper`]: {
          width: props.drawerWidth,
          boxSizing: "border-box",
          border: "none",
          backgroundColor: mobileTemporary ? color.TableBgColor : props.res === "main" ? "transparent" : "default",
          mt: { xs: mobileTemporary ? 0 : props.res === "main" ? 0 : "9vh" },
          boxShadow: mobileTemporary ? 3 : props.res === "main" ? 0 : 3,
        },
      }}
    >
      <Toolbar
        sx={{ display: isMainNav ? "block" : "none" }}
      ></Toolbar>
      <Box sx={{ overflow: "auto", pt: mobileTemporary ? "0.75rem" : 0 }}>
        {/* <List
          sx={{
            width: "100%",
            // bgcolor: "background.paper",
            backgroundColor: "transparent",
            display: "flex",
            flexDirection: "column",
            gap: color.sideNavWholeGap,
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
        
       </List> */}
        <TreeView
          aria-label="Location Tree"
          defaultCollapseIcon={<ExpandMoreIcon sx={{ color: "#828079" }} />}
          //  defaultExpanded={expanded}
          defaultExpandIcon={<ChevronRightIcon sx={{ color: "#828079" }} />}
          sx={{
            "& .MuiTreeItem-root": {
              "& .MuiTreeItem-content": {
                "& .MuiTreeItem-label": {
                  paddingLeft: "1em",
                },
                "& .MuiTreeItem-iconContainer": {
                  paddingLeft: "0.5em",
                },
              },
            },
          }}
        >
          {data.map((list, i) => (
            <Box key={i}>{renderTree(list)}</Box>
          ))}
        </TreeView>
      </Box>
    </Drawer>
  );
};

export default SideNav;
